import type { PackagingState } from '../upload/toyPackaging'

type Props = {
  state: PackagingState | { status: string }
}

export default function PackagingStatus({ state }: Props) {
  if (state.status === 'preparing') {
    const s = state as Extract<PackagingState, { status: 'preparing' }>
    return (
      <p className="music-player__status music-player__status--info">
        <span className="music-player__spinner" aria-hidden="true" />
        {s.step}
      </p>
    )
  }
  if (state.status === 'uploading') {
    const s = state as Extract<PackagingState, { status: 'uploading' }>
    return (
      <p className="music-player__status music-player__status--info">
        <span className="music-player__spinner" aria-hidden="true" />
        Uploading {s.progress.completed} of {s.progress.total}
        {s.progress.currentName && ` — ${s.progress.currentName}`}
      </p>
    )
  }
  if (state.status === 'error') {
    const s = state as Extract<PackagingState, { status: 'error' }>
    return (
      <p className="music-player__status music-player__status--err">
        Upload failed: {s.message}
      </p>
    )
  }
  return null
}
